
  (function () {
    
    function init() {
      var root = document.querySelector("[data-altair-cookie]");
      if (!root || root.dataset.acBound === '1') return;
      root.dataset.acBound = '1';
      var DELAY = parseInt(root.getAttribute('data-delay'), 10);
      if (isNaN(DELAY)) DELAY = 700;
      var showTimer;

      /* Filet de sécurité : si l'API de consentement n'est jamais disponible,
         on rend le bandeau natif Shopify à nouveau visible. Mieux vaut deux
         bandeaux qu'aucun. */
      var watchdog = window.setTimeout(function () {
        var st = document.querySelector('style[data-ac-hide-native]');
        if (st) st.disabled = true;
      }, 6000);
      function operational() { window.clearTimeout(watchdog); }

      function show() {
        root.hidden = false;
        /* force un reflow pour que la transition parte bien de l'état initial */
        void root.offsetWidth;
        root.classList.add('is-open');
      }

      function hide() {
        window.clearTimeout(showTimer);
        root.classList.remove('is-open', 'is-prefs');
        window.setTimeout(function () {
          if (!root.classList.contains('is-open')) root.hidden = true;
        }, 420);
      }

      function api() {
        return (window.Shopify && window.Shopify.customerPrivacy) || null;
      }

      function apply(consent) {
        var cp = api();
        if (!cp || typeof cp.setTrackingConsent !== 'function') return;
        try {
          cp.setTrackingConsent(consent, function () { hide(); });
        } catch (e) {}
      }

      function readCategories() {
        var boxes = root.querySelectorAll('[data-ac-cat]');
        var out = { analytics: false, marketing: false, preferences: false };
        for (var i = 0; i < boxes.length; i++) {
          out[boxes[i].getAttribute('data-ac-cat')] = boxes[i].checked;
        }
        return out;
      }

      function choiceRecorded(cp) {
        if (typeof cp.currentVisitorConsent !== 'function') return false;
        var choice = cp.currentVisitorConsent();
        return choice && ['analytics', 'marketing', 'preferences'].every(function (purpose) {
          return choice[purpose] === 'yes' || choice[purpose] === 'no';
        });
      }

      function loadSelectedCategories() {
        var cp = api();
        if (!cp || typeof cp.currentVisitorConsent !== 'function') return;
        var choice = cp.currentVisitorConsent();
        root.querySelectorAll('[data-ac-cat]').forEach(function (box) {
          box.checked = choice[box.getAttribute('data-ac-cat')] === 'yes';
        });
      }

      root.addEventListener('click', function (ev) {
        if (!ev.target || !ev.target.closest) return;
        var el = ev.target.closest('[data-ac]');
        if (!el) return;
        var act = el.getAttribute('data-ac');

        if (act === 'open-prefs') {
          loadSelectedCategories();
          root.classList.add('is-prefs');
          return;
        }
        if (act === 'accept' || act === 'accept-all') {
          apply({ analytics: true, marketing: true, preferences: true });
          return;
        }
        if (act === 'decline') {
          apply({ analytics: false, marketing: false, preferences: false });
          return;
        }
        if (act === 'save') {
          apply(readCategories());
          return;
        }
      });

      /* Rouvrir le bandeau depuis n'importe quel lien du site. */
      window.ALTAIRCookies = {
        open: function () { root.classList.remove('is-prefs'); show(); },
        settings: function () { loadSelectedCategories(); root.classList.add('is-prefs'); show(); }
      };
      document.addEventListener('click', function (ev) {
        if (!ev.target || !ev.target.closest) return;
        var t = ev.target.closest('[data-altair-cookie-settings]');
        if (!t) return;
        ev.preventDefault();
        window.ALTAIRCookies.settings();
      });

      function decide() {
        var cp = api();
        if (!cp) return;
        operational();
        var should = false;
        try {
          if (typeof cp.shouldShowBanner === 'function') {
            should = cp.shouldShowBanner() && !choiceRecorded(cp);
          }
        } catch (e) {
          should = false;
        }
        if (should) showTimer = window.setTimeout(show, DELAY);
        else hide();
      }

      if (api()) {
        decide();
      } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) { if (!error) decide(); }
        );
      } else {
        document.addEventListener('visitorConsentCollected', function () { hide(); });
      }
      document.addEventListener('visitorConsentCollected', hide);
      document.addEventListener('shopify:section:select', function (event) {
        if (root.closest('#shopify-section-' + event.detail.sectionId)) show();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
